<template>
  <div
    class="VersionHistory mt-3 pb-3 border-inverted border-bottom border-thick"
  >
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">Version Notes</h2>

    <ToggleMoreSection section-name="version notes" button-classes="ml-2">
      <div class="ml-2 pl-0 font-smaller">
        {{ article.versionNote }}
      </div>
    </ToggleMoreSection>
  </div>
</template>

<script>
import ToggleMoreSection from "~/components/page/components/buttons/ToggleMoreSection.vue";

export default {
  name: "VersionHistory",
  components: { ToggleMoreSection },
  props: {
    article: { type: Object, required: true },
  },
};
</script>
